/**
 * © 2026 iTech India Private Limited. All rights reserved.
 * Licensed under the iTech End User License Agreement (EULA).
 * Unauthorized use or distribution is prohibited.
 */

/**
 * Malayalam strings — initial machine-assisted draft, pending translation-vendor
 * review (tracked as dependency E8). Missing keys fall back to English.
 */
const CLIENT = 'ക്ലയന്റ്';
const SESSIONS = 'സെഷനുകൾ';
const THERAPIST = 'തെറാപ്പിസ്റ്റ്';
const STATUS = 'നില';
const PLAN = 'പ്ലാൻ';
const MRR = 'MRR';
const TRIAL = 'ട്രയൽ';
const SUBSCRIPTION = 'സബ്‌സ്ക്രിപ്ഷൻ';
const ACTION = 'നടപടി';
const NO_SESSIONS = 'ഷെഡ്യൂൾ ചെയ്ത സെഷനുകളില്ല.';
const THERAPY_PLANS = 'തെറാപ്പി പ്ലാനുകൾ';
const REPORTS = 'റിപ്പോർട്ടുകൾ';
const HOME_TASKS = 'ഹോം ടാസ്‌ക്കുകൾ';
const SELECT_A_CLIENT = 'ഒരു ക്ലയന്റിനെ തിരഞ്ഞെടുക്കുക';
const TYPE = 'തരം';
const TIME = 'സമയം';
const ACTIONS = 'നടപടികൾ';
const PROGRESS = 'പുരോഗതി';
const CITY = 'നഗരം';
const STATE_LABEL = 'സംസ്ഥാനം';
const POSTAL_CODE = 'പിൻ കോഡ്';
const LEGAL_NAME = 'നിയമപരമായ പേര്';
const CONTACT_EMAIL = 'ബന്ധപ്പെടാനുള്ള ഇമെയിൽ';
const CONTACT_PHONE = 'ബന്ധപ്പെടാനുള്ള ഫോൺ';
const TIMEZONE = 'സമയ മേഖല';
const AMOUNT_RUPEES = 'തുക (₹)';
const FULL_NAME = 'പൂർണ്ണ നാമം';
const EMAIL = 'ഇമെയിൽ';
const PHONE = 'ഫോൺ';
const PARENT_FULL_NAME = 'രക്ഷിതാവിന്റെ പൂർണ്ണ നാമം';
const PARENT_EMAIL = 'രക്ഷിതാവിന്റെ ഇമെയിൽ';
const ACTIVE = 'സജീവം';
const SUSPENDED = 'താൽക്കാലികമായി നിർത്തി';
const CANCELLED = 'റദ്ദാക്കി';
const NO_INVOICES = 'ഇൻവോയ്‌സുകളില്ല.';
const DRAFT = 'കരട്';
const PAID = 'പണമടച്ചു';
const ADD_LINE_1 = 'വിലാസ വരി 1';
const COUNTRY_ISO = 'രാജ്യം (ISO)';
const REPORTS_COUNT = '{{count}} റിപ്പോർട്ടുകൾ';
const CURRENT_GOALS = 'നിലവിലെ ലക്ഷ്യങ്ങൾ';
const SUB_TARGETS = 'ഉപ-ലക്ഷ്യങ്ങൾ';
const SAVE_CHANGES = 'മാറ്റങ്ങൾ സംരക്ഷിക്കുക';
const FILTER_BY_STATUS = 'നില അനുസരിച്ച് ഫിൽട്ടർ ചെയ്യുക';
const ALL_STATUS = 'എല്ലാ നിലകളും';

export default {
  common: {
    appName: 'TherapyOS',
    loading: 'ലോഡ് ചെയ്യുന്നു…',
    save: SAVE_CHANGES,
    cancel: 'റദ്ദാക്കുക',
    signOut: 'ലോഗൗട്ട്',
    search: 'തിരയുക…',
    notFound: 'പേജ് കണ്ടെത്തിയില്ല',
    backHome: 'ഹോമിലേക്ക് മടങ്ങുക',
    loadError: 'ഡാറ്റ ലോഡ് ചെയ്യാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
    saveError: 'സംരക്ഷിക്കാനായില്ല. ദയവായി ഫോം പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
    view: 'കാണുക',
    edit: 'എഡിറ്റ് ചെയ്യുക',
    delete: 'ഇല്ലാതാക്കുക',
  },
  topbar: {
    back: 'പിന്നോട്ട് പോകുക',
    welcome: 'വീണ്ടും സ്വാഗതം',
    welcomeName: 'വീണ്ടും സ്വാഗതം, {{name}}',
    addNew: 'പുതിയത് ചേർക്കുക',
    notifications: 'അറിയിപ്പുകൾ',
    noNotifications: 'പുതിയ അറിയിപ്പുകളില്ല',
    toggleTheme: 'ഡാർക്ക് മോഡ് മാറ്റുക',
  },
  status: {
    active: ACTIVE,
    inactive: 'നിഷ്‌ക്രിയം',
    discharged: 'ഡിസ്ചാർജ് ചെയ്തു',
    scheduled: 'ഷെഡ്യൂൾ ചെയ്തു',
    in_progress: 'പുരോഗമിക്കുന്നു',
    completed: 'പൂർത്തിയായി',
    cancelled: 'റദ്ദാക്കി',
    no_show: 'ഹാജരായില്ല',
  },
  goalStatus: {
    not_started: 'ആരംഭിച്ചിട്ടില്ല',
    emerging: 'ഉയർന്നുവരുന്നു',
    in_progress: 'പുരോഗമിക്കുന്നു',
    achieved: 'നേടി',
    maintenance: 'പരിപാലനം',
    discontinued: 'നിർത്തലാക്കി',
  },
  measurementType: {
    frequency: 'ആവൃത്തി',
    percent_accuracy: 'ശതമാന കൃത്യത',
    duration: 'ദൈർഘ്യം',
    latency: 'കാലതാമസം',
    trials_to_criterion: 'മാനദണ്ഡം വരെയുള്ള ശ്രമങ്ങൾ',
    rating_scale: 'റേറ്റിംഗ് സ്കെയിൽ',
    independence_level: 'സ്വാതന്ത്ര്യ നില',
    prompt_level: 'സൂചന നില',
    anecdotal: 'വിവരണാത്മകം',
  },
  sessionType: {
    individual: 'വ്യക്തിഗതം',
    group: 'ഗ്രൂപ്പ്',
    teletherapy: 'ടെലിതെറാപ്പി',
    assessment: 'വിലയിരുത്തൽ',
    review: 'അവലോകനം',
    supervision: 'മേൽനോട്ടം',
    home_visit: 'വീട് സന്ദർശനം',
  },
  therapist: {
    dashboard: {
      myClients: 'എന്റെ ക്ലയന്റുകൾ',
      upcoming: 'വരാനിരിക്കുന്ന സെഷനുകൾ',
      plans: THERAPY_PLANS,
    },
    clients: {
      title: 'എന്റെ ക്ലയന്റുകൾ',
      count: '{{count}} ക്ലയന്റുകൾ',
      searchPlaceholder: 'ക്ലയന്റുകളെ തിരയുക…',
      empty: 'ഇതുവരെ ക്ലയന്റുകളെ നിയോഗിച്ചിട്ടില്ല.',
    },
    notes: {
      title: 'സെഷൻ കുറിപ്പുകൾ',
      subtitle: 'നിങ്ങളുടെ സെഷനുകൾ രേഖപ്പെടുത്തുക',
      count: 'രേഖപ്പെടുത്താൻ {{count}} സെഷനുകൾ',
      empty: 'ഇതുവരെ രേഖപ്പെടുത്താൻ സെഷനുകളില്ല.',
      open: 'കുറിപ്പ് തുറക്കുക',
    },
    schedule: {
      title: 'ഷെഡ്യൂൾ',
      subtitle: 'നിങ്ങളുടെ പ്രതിവാര സെഷൻ കലണ്ടർ',
      add: 'പുതിയ സെഷൻ',
      empty: 'വരാനിരിക്കുന്ന സെഷനുകളില്ല.',
      noneDay: 'സെഷനുകളില്ല',
      prevWeek: 'കഴിഞ്ഞ ആഴ്ച',
      nextWeek: 'അടുത്ത ആഴ്ച',
      thisWeek: 'ഈ ആഴ്ച',
    },
    availability: {
      title: 'ലഭ്യത',
      subtitle: 'നിങ്ങളുടെ ആവർത്തന പ്രതിവാര ജോലി സമയം',
      save: 'ലഭ്യത സംരക്ഷിക്കുക',
      saved: 'ലഭ്യത സംരക്ഷിച്ചു.',
      saveError: 'ലഭ്യത സംരക്ഷിക്കാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
      invalid:
        'നിങ്ങളുടെ സമയ വിൻഡോകൾ പരിശോധിക്കുക — അവസാനം തുടക്കത്തിന് ശേഷമായിരിക്കണം, വിൻഡോകൾ പരസ്പരം ഓവർലാപ്പ് ചെയ്യരുത്.',
      addWindow: 'വിൻഡോ ചേർക്കുക',
      removeWindow: 'വിൻഡോ നീക്കം ചെയ്യുക',
      none: 'ലഭ്യമല്ല',
      days: {
        mon: 'തിങ്കൾ',
        tue: 'ചൊവ്വ',
        wed: 'ബുധൻ',
        thu: 'വ്യാഴം',
        fri: 'വെള്ളി',
        sat: 'ശനി',
        sun: 'ഞായർ',
      },
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'ഇന്നത്തെ സെഷനുകളും ജീവിതചക്രവും',
      empty: NO_SESSIONS,
      colClient: CLIENT,
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
      colActions: ACTIONS,
      start: 'ആരംഭിക്കുക',
      complete: 'പൂർത്തിയാക്കുക',
      cancel: 'റദ്ദാക്കുക',
      reschedule: 'വീണ്ടും ഷെഡ്യൂൾ ചെയ്യുക',
      note: 'സെഷൻ കുറിപ്പ്',
      rate: 'റേറ്റ് ചെയ്യുക',
      rescheduleTitle: 'സെഷൻ വീണ്ടും ഷെഡ്യൂൾ ചെയ്യുക',
      rescheduleSubtitle:
        'പുതിയ സമയം തിരഞ്ഞെടുക്കുക. തെറാപ്പിസ്റ്റിന്റെ മറ്റ് സെഷനുകളുമായുള്ള വൈരുദ്ധ്യങ്ങൾ നിരസിക്കപ്പെടും.',
    },
    rate: {
      title: 'സെഷൻ റേറ്റ് ചെയ്യുക',
      subtitle: 'ഇടപെടൽ, സഹകരണം, സന്ദർഭം',
      engagement: 'ഇടപെടൽ',
      cooperation: 'സഹകരണം',
      note: 'സന്ദർഭ കുറിപ്പ്',
      unrated: 'റേറ്റ് ചെയ്തിട്ടില്ല',
      submit: 'റേറ്റിംഗ് സംരക്ഷിക്കുക',
    },
    note: {
      title: 'സെഷൻ കുറിപ്പ്',
      back: 'സെഷനുകളിലേക്ക് മടങ്ങുക',
      signed: 'ഒപ്പിട്ടു',
      trials: 'ലക്ഷ്യ ട്രയൽ ഡാറ്റ',
      correct: 'ശരി',
      incorrect: 'തെറ്റ്',
      prompted: 'പ്രേരിപ്പിച്ചു',
      subjective: 'ആത്മനിഷ്ഠം',
      objective: 'വസ്തുനിഷ്ഠം',
      assessment: 'വിലയിരുത്തൽ',
      plan: PLAN,
      saveDraft: 'കരട് സംരക്ഷിക്കുക',
      sign: 'ഒപ്പിട്ട് ലോക്ക് ചെയ്യുക',
    },
    plans: {
      title: THERAPY_PLANS,
      subtitle: 'നിങ്ങളുടെ ക്ലയന്റുകൾക്കായുള്ള വ്യക്തിഗത തെറാപ്പി പ്ലാനുകൾ',
      count: '{{count}} സജീവ പ്ലാനുകൾ',
      searchPlaceholder: 'പേര് അനുസരിച്ച് പ്ലാനുകൾ തിരയുക…',
      empty: 'ഇതുവരെ തെറാപ്പി പ്ലാനുകളില്ല.',
      progress: 'മൊത്തം പുരോഗതി',
      review: 'അവലോകനം',
      reviewDate: 'അവലോകന തീയതി',
      currentGoals: CURRENT_GOALS,
      moreGoals: '+{{count}} കൂടുതൽ',
      viewDetails: 'വിശദാംശങ്ങൾ കാണുക',
      updateProgress: 'പുരോഗതി അപ്‌ഡേറ്റ് ചെയ്യുക',
      detailsTitle: 'തെറാപ്പി പ്ലാൻ വിശദാംശങ്ങൾ',
      client: CLIENT,
      program: 'പ്രോഗ്രാം',
      startDate: 'ആരംഭ തീയതി',
      goals: 'ലക്ഷ്യങ്ങൾ',
    },
    planForm: {
      newPlan: 'പുതിയ പ്ലാൻ',
      subtitle: 'ഒരു ക്ലയന്റിനായി തെറാപ്പി പ്ലാനും അതിന്റെ ലക്ഷ്യങ്ങളും നിർമ്മിക്കുക.',
      fromTemplate: 'ഒരു ടെംപ്ലേറ്റിൽ നിന്ന് ആരംഭിക്കുക',
      fromTemplateNone: 'ടെംപ്ലേറ്റ് ഇല്ല — ശൂന്യമായി ആരംഭിക്കുക',
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      name: 'പ്ലാൻ പേര്',
      programType: 'പ്രോഗ്രാം തരം',
      startDate: 'ആരംഭ തീയതി',
      reviewDate: 'അവലോകന തീയതി',
      goals: 'ലക്ഷ്യങ്ങൾ',
      addGoal: 'ലക്ഷ്യം ചേർക്കുക',
      goalN: 'ലക്ഷ്യം {{n}}',
      goalTitle: 'ലക്ഷ്യം',
      domain: 'മേഖല',
      selectDomain: 'മേഖല തിരഞ്ഞെടുക്കുക',
      measurementType: 'അളവ് രീതി',
      selectMeasurementType: 'രീതി തിരഞ്ഞെടുക്കുക',
      measure: 'അളവ് വിശദാംശം',
      baseline: 'അടിസ്ഥാനരേഖ',
      target: 'ലക്ഷ്യം',
      goalReviewDate: 'ലക്ഷ്യ പുനഃപരിശോധന തീയതി',
      approachTags: 'സമീപന ടാഗുകൾ',
      approachTagsHint: 'കോമ ഉപയോഗിച്ച് വേർതിരിച്ചത്, ഉദാ. PECS, DTT',
      subTargets: SUB_TARGETS,
      subTargetsHint:
        '; ഉപയോഗിച്ച് വേർതിരിക്കുക — > ന് ശേഷം ഘട്ടങ്ങൾ ചേർക്കുക, ഉദാ. അനുകരണം > മാതൃക, സൂചന',
      removeGoal: 'ലക്ഷ്യം നീക്കം ചെയ്യുക',
      submit: 'പ്ലാൻ സൃഷ്ടിക്കുക',
    },
    plan: {
      back: 'പ്ലാനുകളിലേക്ക് മടങ്ങുക',
      goals: CURRENT_GOALS,
      noGoals: 'ഈ പ്ലാനിന് ഇതുവരെ ലക്ഷ്യങ്ങളില്ല.',
      updateStatus: 'ലക്ഷ്യ നില അപ്‌ഡേറ്റ് ചെയ്യുക',
      subTargets: SUB_TARGETS,
      reviewBy: '{{date}} നകം പുനഃപരിശോധന',
      statusNote: 'നില-മാറ്റ കുറിപ്പ് (ഐച്ഛികം)',
      statusNotePlaceholder: 'നില എന്തുകൊണ്ട് മാറുന്നു?',
      history: 'നില ചരിത്രം',
      showHistory: 'നില ചരിത്രം',
      hideHistory: 'ചരിത്രം മറയ്ക്കുക',
      noHistory: 'ഇതുവരെ നില മാറ്റം രേഖപ്പെടുത്തിയിട്ടില്ല.',
      historyEntry: '{{from}} → {{to}}',
      historyInitial: '{{to}} ആയി സജ്ജമാക്കി',
      saveAsTemplate: 'ടെംപ്ലേറ്റായി സംരക്ഷിക്കുക',
      exportPdf: 'PDF കയറ്റുമതി ചെയ്യുക',
      exporting: 'കയറ്റുമതി ചെയ്യുന്നു…',
      saveTemplateTitle: 'ടെംപ്ലേറ്റായി സംരക്ഷിക്കുക',
      saveTemplateSubtitle:
        'ഭാവിയിലെ പ്ലാനുകൾ സൃഷ്ടിക്കുമ്പോൾ ഈ പ്ലാനിന്റെ ലക്ഷ്യങ്ങൾ വീണ്ടും ഉപയോഗിക്കുക.',
      templateName: 'ടെംപ്ലേറ്റ് പേര്',
    },
    templates: {
      title: 'ടെംപ്ലേറ്റുകൾ',
      subtitle: 'നിങ്ങളുടെ ക്ലിനിക്കിനായി വീണ്ടും ഉപയോഗിക്കാവുന്ന പ്ലാൻ ലക്ഷ്യ സെറ്റുകൾ',
      empty:
        'ഇതുവരെ ടെംപ്ലേറ്റുകളില്ല. ലക്ഷ്യങ്ങൾ വീണ്ടും ഉപയോഗിക്കാൻ ഒരു പ്ലാൻ ടെംപ്ലേറ്റായി സംരക്ഷിക്കുക.',
      goalCount: '{{count}} ലക്ഷ്യങ്ങൾ',
      delete: 'ടെംപ്ലേറ്റ് ഇല്ലാതാക്കുക',
    },
    collaborators: {
      title: 'സഹകരിക്കുന്ന തെറാപ്പിസ്റ്റുകൾ',
      none: 'ഇതുവരെ സഹകാരികളില്ല.',
      add: 'സഹകാരിയെ ചേർക്കുക…',
      remove: 'സഹകാരിയെ നീക്കം ചെയ്യുക',
    },
    review: {
      title: 'ക്ലിനിക്കൽ അവലോകനങ്ങൾ',
      due: 'അവലോകനം ബാക്കി',
      dueBanner: '{{count}} പ്ലാനുകൾ ക്ലിനിക്കൽ അവലോകനത്തിന് ബാക്കിയുണ്ട്',
      record: 'അവലോകനം രേഖപ്പെടുത്തുക',
      empty: 'ഇതുവരെ അവലോകനങ്ങൾ രേഖപ്പെടുത്തിയിട്ടില്ല.',
      modalTitle: 'ക്ലിനിക്കൽ അവലോകനം രേഖപ്പെടുത്തുക',
      modalSubtitle: 'അവലോകന ഫലം രേഖപ്പെടുത്തി അടുത്ത അവലോകന തീയതി സജ്ജമാക്കുക.',
      outcome: 'ഫലം',
      outcome_continue: 'പ്ലാൻ തുടരുക',
      outcome_revise: 'പ്ലാൻ പരിഷ്കരിക്കുക',
      outcome_discharge: 'ഡിസ്ചാർജ്',
      summary: 'സംഗ്രഹം',
      recommendations: 'ശുപാർശകൾ (ഓപ്ഷണൽ)',
      nextDate: 'അടുത്ത അവലോകന തീയതി',
      submit: 'അവലോകനം സംരക്ഷിക്കുക',
    },
    homeTasks: {
      link: HOME_TASKS,
      back: 'എന്റെ ക്ലയന്റുകളിലേക്ക് മടങ്ങുക',
      title: HOME_TASKS,
      subtitle: 'ഹോം-പ്രോഗ്രാം ടാസ്‌ക്കുകൾ നിയോഗിക്കുകയും അവലോകനം ചെയ്യുകയും ചെയ്യുക',
    },
  },
  parent: {
    selectChild: 'കുട്ടി',
    noData: 'ഇതുവരെ ഡാറ്റ രേഖപ്പെടുത്തിയിട്ടില്ല',
    dashboard: {
      title: 'സ്വാഗതം',
      subtitle: 'നിങ്ങളുടെ കുട്ടികളുടെ തെറാപ്പി ഒറ്റനോട്ടത്തിൽ',
      empty: 'ഇതുവരെ കുട്ടികളെ ചേർത്തിട്ടില്ല.',
      progress: 'മൊത്തം പുരോഗതി',
      viewProgress: 'പുരോഗതി കാണുക →',
      recentReports: 'സമീപകാല റിപ്പോർട്ടുകൾ',
    },
    achievements: {
      dayStreak: '{{count}} ദിവസത്തെ തുടർച്ച',
      completed: '{{count}} പൂർത്തിയായി',
      badge: {
        firstStep: 'ആദ്യ ചുവട്',
        threeDay: '3-ദിവസത്തെ തുടർച്ച',
        weekWarrior: 'വാര യോദ്ധാവ്',
        fiftyDone: '50 പൂർത്തിയായി',
      },
    },
    progress: {
      title: PROGRESS,
      subtitle: 'കാലക്രമേണ ലക്ഷ്യ കൃത്യത',
      empty: 'ഇതുവരെ പുരോഗതി ഡാറ്റ രേഖപ്പെടുത്തിയിട്ടില്ല.',
    },
    sessions: {
      title: SESSIONS,
      subtitle: 'നിങ്ങളുടെ കുട്ടികളുടെ തെറാപ്പി ഷെഡ്യൂൾ',
      empty: NO_SESSIONS,
      colChild: 'കുട്ടി',
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
    },
    billing: {
      title: 'ബില്ലിംഗ്',
      subtitle: 'നിങ്ങളുടെ ഇൻവോയ്‌സുകളും പേയ്‌മെന്റുകളും',
      empty: NO_INVOICES,
      payNow: 'ഇപ്പോൾ പണമടയ്ക്കുക',
      payNowTitle: 'ഇൻവോയ്‌സ് പണമടയ്ക്കുക',
      payNowSubtitle: 'കുടിശ്ശിക തുക സുരക്ഷിതമായി അടയ്ക്കുക (Razorpay).',
      payConfirm: 'ഇപ്പോൾ പണമടയ്ക്കുക',
      paying: 'പ്രോസസ് ചെയ്യുന്നു…',
      payError: 'പണമടവ് പ്രോസസ് ചെയ്യാനായില്ല. വീണ്ടും ശ്രമിക്കുക.',
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
      empty: 'ഇതുവരെ നിങ്ങളുമായി റിപ്പോർട്ടുകളൊന്നും പങ്കിട്ടിട്ടില്ല.',
    },
    homeTasks: {
      title: HOME_TASKS,
      subtitle: 'ഇന്നത്തെ വീട്ടിലെ തെറാപ്പി പരിശീലനം',
      dailyProgress: 'ദൈനംദിന പുരോഗതി',
      completedCount: '{{total}} ൽ {{done}} ഇന്ന് പൂർത്തിയായി',
      completed: 'പൂർത്തിയായി ✓',
      dueToday: 'ഇന്ന് ചെയ്യേണ്ടത്',
      markDone: 'പൂർത്തിയായതായി അടയാളപ്പെടുത്തുക',
      empty: 'ഇതുവരെ ഹോം ടാസ്‌ക്കുകൾ നിയോഗിച്ചിട്ടില്ല.',
    },
  },
  admin: {
    dashboard: {
      activeClients: 'സജീവ ക്ലയന്റുകൾ',
      therapists: 'തെറാപ്പിസ്റ്റുകൾ',
      sessions: SESSIONS,
      sessionsThisMonth: 'ഈ മാസത്തെ സെഷനുകൾ',
      avgProgress: 'ശരാശരി പ്ലാൻ പുരോഗതി',
      plans: THERAPY_PLANS,
      distribution: 'ക്ലയന്റ് വിതരണം',
      distributionSub: 'തെറാപ്പി തരം അനുസരിച്ച്',
      sessionsTrend: 'സെഷനുകൾ',
      sessionsTrendSub: 'കഴിഞ്ഞ 6 മാസം',
      performance: 'തെറാപ്പിസ്റ്റ് പ്രകടനം',
      performanceSub: 'മികച്ച പ്രകടനക്കാർ',
      sessionsUnit: '{{count}} സെഷനുകൾ',
      upcoming: 'വരാനിരിക്കുന്ന സെഷനുകൾ',
      upcomingSub: 'ഇന്നത്തെ ഷെഡ്യൂൾ',
      noUpcoming: 'വരാനിരിക്കുന്ന സെഷനുകളില്ല.',
      noData: 'ഇതുവരെ ഡാറ്റയില്ല.',
      viewAll: 'എല്ലാം കാണുക',
      activity: 'സമീപകാല പ്രവർത്തനം',
      activitySub: 'അടുത്തിടെ പൂർത്തിയാക്കിയ സെഷനുകൾ',
      noActivity: 'സമീപകാല പ്രവർത്തനമൊന്നുമില്ല.',
      activitySession: '{{client}} ഒരു സെഷൻ പൂർത്തിയാക്കി',
    },
    clients: {
      title: 'ക്ലയന്റ് മാനേജ്‌മെന്റ്',
      subtitle: 'നിങ്ങളുടെ ക്ലിനിക്കിൽ ചേർന്ന കുട്ടികൾ',
      count: 'ആകെ {{count}} ക്ലയന്റുകൾ',
      add: 'ക്ലയന്റിനെ ചേർക്കുക',
      edit: 'ക്ലയന്റിനെ എഡിറ്റ് ചെയ്യുക',
      addSubtitle: 'പുതിയ ക്ലയന്റ് രേഖ സൃഷ്ടിക്കുക',
      empty: 'ഇതുവരെ ക്ലയന്റുകളില്ല. ആരംഭിക്കാൻ നിങ്ങളുടെ ആദ്യ ക്ലയന്റിനെ ചേർക്കുക.',
      searchPlaceholder: 'ക്ലയന്റുകൾ, രോഗനിർണയം, തെറാപ്പിസ്റ്റ് എന്നിവ തിരയുക…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      age: 'പ്രായം {{age}}',
      colName: CLIENT,
      colDiagnosis: 'രോഗനിർണയം',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colProgress: PROGRESS,
      colStatus: STATUS,
      colActions: ACTIONS,
      deleteTitle: 'ക്ലയന്റിനെ ഇല്ലാതാക്കണോ?',
      deleteBody:
        '{{name}} ഉം അവരുടെ എല്ലാ രേഖകളും ശാശ്വതമായി ഇല്ലാതാക്കുക. ഇത് പഴയപടിയാക്കാനാവില്ല.',
    },
    clientDetail: {
      back: 'ക്ലയന്റുകളിലേക്ക് മടങ്ങുക',
      notFound: 'ക്ലയന്റിനെ കണ്ടെത്തിയില്ല.',
      age: 'പ്രായം',
      therapist: THERAPIST,
      guardian: 'രക്ഷിതാവ്',
      contact: 'ബന്ധപ്പെടുക',
      plans: THERAPY_PLANS,
      noPlans: 'ഇതുവരെ തെറാപ്പി പ്ലാനുകളില്ല.',
      sessions: 'സമീപകാല സെഷനുകൾ',
      noSessions: NO_SESSIONS,
      billing: 'ബില്ലിംഗ്',
      noInvoices: NO_INVOICES,
    },
    sessions: {
      title: SESSIONS,
      count: '{{count}} സെഷനുകൾ',
      empty: NO_SESSIONS,
      searchPlaceholder: 'തരം അല്ലെങ്കിൽ സ്ഥലം അനുസരിച്ച് തിരയുക…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      schedule: 'സെഷൻ ഷെഡ്യൂൾ ചെയ്യുക',
      scheduleSubtitle: 'പുതിയ തെറാപ്പി സെഷൻ ബുക്ക് ചെയ്യുക',
      colClient: CLIENT,
      colTherapist: THERAPIST,
      colType: TYPE,
      colTime: TIME,
      colStatus: STATUS,
    },
    users: {
      title: 'ടീം അംഗങ്ങൾ',
      count: 'ആകെ {{count}} ഉപയോക്താക്കൾ',
      invite: 'ഉപയോക്താവിനെ ക്ഷണിക്കുക',
      inviteTitle: 'ഒരു ടീം അംഗത്തെ ക്ഷണിക്കുക',
      inviteSubtitle: 'പാസ്‌വേഡ് സജ്ജമാക്കാൻ അവർക്ക് ഒരു ഇമെയിൽ ലഭിക്കും.',
      empty: 'ഇതുവരെ ടീം അംഗങ്ങളില്ല. ആരംഭിക്കാൻ നിങ്ങളുടെ ആദ്യ ഉപയോക്താവിനെ ക്ഷണിക്കുക.',
      enable: 'പ്രവർത്തനക്ഷമമാക്കുക',
      disable: 'പ്രവർത്തനരഹിതമാക്കുക',
      name: FULL_NAME,
      email: EMAIL,
      role: 'റോൾ',
      inviteError: 'ക്ഷണം അയയ്ക്കാനായില്ല. വീണ്ടും ശ്രമിക്കുക.',
      col: {
        name: 'പേര്',
        email: EMAIL,
        roles: 'റോളുകൾ',
        status: STATUS,
        lastLogin: 'അവസാന ലോഗിൻ',
      },
      role_CLINIC_ADMIN: 'ക്ലിനിക് അഡ്മിൻ',
      role_THERAPIST: THERAPIST,
      role_FINANCE: 'ഫിനാൻസ്',
      status_invited: 'ക്ഷണിച്ചു',
      status_active: ACTIVE,
      status_disabled: 'പ്രവർത്തനരഹിതം',
    },
    therapists: {
      title: 'തെറാപ്പിസ്റ്റ് മാനേജ്‌മെന്റ്',
      subtitle: 'നിങ്ങളുടെ ക്ലിനിക്കിലെ ക്ലിനിക്കൽ ജീവനക്കാർ',
      registered: '{{count}} തെറാപ്പിസ്റ്റുകൾ രജിസ്റ്റർ ചെയ്തു',
      add: 'തെറാപ്പിസ്റ്റിനെ ചേർക്കുക',
      addSubtitle: 'പുതിയ തെറാപ്പിസ്റ്റ് പ്രൊഫൈൽ സൃഷ്ടിക്കുക',
      empty: 'ഇതുവരെ തെറാപ്പിസ്റ്റുകളില്ല. ആരംഭിക്കാൻ നിങ്ങളുടെ ആദ്യ തെറാപ്പിസ്റ്റിനെ ചേർക്കുക.',
      searchPlaceholder: 'തെറാപ്പിസ്റ്റുകളെ തിരയുക…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      clients: 'ക്ലയന്റുകൾ',
      sessions: SESSIONS,
      rating: 'റേറ്റിംഗ്',
      joined: '{{date}} ന് ചേർന്നു',
    },
    finance: {
      title: 'ഫിനാൻസ്',
      count: '{{count}} ഇൻവോയ്‌സുകൾ',
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
    },
    invite: {
      title: 'രക്ഷിതാവിനെ ക്ഷണിക്കുക',
      subtitle: 'ഈ കുട്ടിക്കായി ഒരു രക്ഷിതാവ് ലോഗിൻ സൃഷ്ടിക്കുക',
      intro: '{{child}} ന്റെ രക്ഷിതാവിന് പേരന്റ് പോർട്ടൽ ആക്‌സസ് ചെയ്യാൻ ഒരു ക്ഷണം അയയ്ക്കുക.',
      parentName: PARENT_FULL_NAME,
      email: PARENT_EMAIL,
      submit: 'ക്ഷണം അയയ്ക്കുക',
      error: 'ക്ഷണം അയയ്ക്കാനായില്ല. ഇമെയിൽ ഇതിനകം ഉപയോഗത്തിലുണ്ടാകാം.',
      success: '{{email}} ലേക്ക് ക്ഷണം ഇമെയിൽ ചെയ്തു.',
      linkLabel: 'ആക്ടിവേഷൻ ലിങ്ക്',
      copy: 'പകർത്തുക',
      copied: 'പകർത്തി',
      note: 'ഞങ്ങൾ ഈ ലിങ്ക് രക്ഷിതാവിന് ഇമെയിൽ ചെയ്തു. നിങ്ങൾക്ക് ഇത് പകർത്തി പങ്കിടാനും കഴിയും — ഇത് അവർക്ക് ഒരു പാസ്‌വേഡ് സജ്ജമാക്കി സൈൻ ഇൻ ചെയ്യാൻ അനുവദിക്കുന്നു, 7 ദിവസത്തിനുള്ളിൽ കാലഹരണപ്പെടും.',
    },
  },
  form: {
    client: {
      fullName: FULL_NAME,
      age: 'പ്രായം',
      primaryDiagnosis: 'രോഗനിർണയം',
      email: EMAIL,
      phone: PHONE,
      assignTherapist: 'നിയോഗിച്ച തെറാപ്പിസ്റ്റ്',
      noTherapist: 'തെറാപ്പിസ്റ്റിനെ നിയോഗിച്ചിട്ടില്ല',
      submit: 'ക്ലയന്റിനെ ചേർക്കുക',
      guardianName: 'രക്ഷിതാവ് / സംരക്ഷകൻ പേര്',
      inviteParentNow: 'ഒരു രക്ഷിതാവ് ലോഗിനും സൃഷ്ടിക്കുക',
      inviteParentHint:
        'പേരന്റ് പോർട്ടൽ ആക്‌സസ് ചെയ്യാൻ ഞങ്ങൾ രക്ഷിതാവിന് ഒരു ആക്ടിവേഷൻ ലിങ്ക് ഇമെയിൽ ചെയ്യും.',
      parentName: PARENT_FULL_NAME,
      parentEmail: PARENT_EMAIL,
    },
    therapist: {
      fullName: FULL_NAME,
      email: EMAIL,
      phone: PHONE,
      specialty: 'വൈദഗ്ധ്യം',
      specialisations: 'വൈദഗ്ധ്യങ്ങൾ',
      specialisationsHint: 'കോമ ഉപയോഗിച്ച് വേർതിരിച്ചത്, ഉദാ. ASD, സ്പീച്ച്, OT',
      joinedOn: 'ചേർന്ന തീയതി',
      submit: 'തെറാപ്പിസ്റ്റിനെ ചേർക്കുക',
    },
    session: {
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      therapist: THERAPIST,
      anyTherapist: 'ലഭ്യമായ ഏതെങ്കിലും തെറാപ്പിസ്റ്റ്',
      type: 'സെഷൻ തരം',
      typeHint: 'ഉദാ. സ്പീച്ച് തെറാപ്പി',
      anyType: 'ഏതെങ്കിലും തരം',
      start: 'തീയതി & സമയം',
      submit: 'സെഷൻ ഷെഡ്യൂൾ ചെയ്യുക',
    },
    reschedule: {
      start: 'പുതിയ തീയതി & സമയം',
      submit: 'വീണ്ടും ഷെഡ്യൂൾ ചെയ്യുക',
      conflict: 'ആ സമയം ഈ തെറാപ്പിസ്റ്റിന്റെ മറ്റൊരു സെഷനുമായി വൈരുദ്ധ്യപ്പെടുന്നു.',
    },
    invoice: {
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      service: 'സേവനം',
      serviceCustom: 'ഇഷ്ടാനുസൃത തുക',
      amount: AMOUNT_RUPEES,
      amountHint: 'ഉദാ. 2500',
      dueDate: 'അവസാന തീയതി',
      notes: 'കുറിപ്പുകൾ',
      notesHint: 'ഉദാ. ജൂൺ സ്പീച്ച്-തെറാപ്പി സെഷനുകൾ',
      submit: 'ഇൻവോയ്‌സ് സൃഷ്ടിക്കുക',
    },
    payment: {
      balance: 'കുടിശ്ശിക ബാലൻസ്: {{amount}}',
      amount: AMOUNT_RUPEES,
      method: 'പേയ്‌മെന്റ് രീതി',
      selectMethod: 'ഒരു രീതി തിരഞ്ഞെടുക്കുക',
      submit: 'പേയ്‌മെന്റ് രേഖപ്പെടുത്തുക',
    },
    homeTask: {
      title: 'ടാസ്‌ക്',
      titleHint: 'ഉദാ. കളിസമയത്ത് കണ്ണ് സമ്പർക്കം പരിശീലിക്കുക (10 മിനി)',
      category: 'വിഭാഗം',
      selectCategory: 'ഒരു വിഭാഗം തിരഞ്ഞെടുക്കുക',
      instructions: 'നിർദ്ദേശങ്ങൾ',
      instructionsHint: 'രക്ഷിതാവിനുള്ള ഓപ്ഷണൽ മാർഗ്ഗനിർദ്ദേശം',
      submit: 'ടാസ്‌ക് നിയോഗിക്കുക',
    },
  },
  login: {
    welcome: 'വീണ്ടും സ്വാഗതം',
    subtitle: 'നിങ്ങളുടെ പോർട്ടലിലേക്ക് സൈൻ ഇൻ ചെയ്യുക',
    selectRole: 'നിങ്ങളുടെ റോൾ തിരഞ്ഞെടുക്കുക',
    email: 'ഇമെയിൽ വിലാസം',
    emailPlaceholder: 'നിങ്ങളുടെ ഇമെയിൽ നൽകുക',
    password: 'പാസ്‌വേഡ്',
    passwordPlaceholder: 'നിങ്ങളുടെ പാസ്‌വേഡ് നൽകുക',
    signInTo: '{{portal}} ലേക്ക് സൈൻ ഇൻ ചെയ്യുക',
    selectClinic: 'നിങ്ങളുടെ ക്ലിനിക് തിരഞ്ഞെടുക്കുക',
    invalidCredentials: 'ഇമെയിൽ അല്ലെങ്കിൽ പാസ്‌വേഡ് തെറ്റാണ്',
    accountLocked: 'അക്കൗണ്ട് താൽക്കാലികമായി ലോക്ക് ചെയ്തു. പിന്നീട് വീണ്ടും ശ്രമിക്കുക.',
    forgotPassword: 'പാസ്‌വേഡ് മറന്നോ?',
    roles: {
      CLINIC_ADMIN: {
        title: 'അഡ്മിൻ പോർട്ടൽ',
        blurb: 'പൂർണ്ണ സിസ്റ്റം നിയന്ത്രണവും മാനേജ്‌മെന്റും',
      },
      THERAPIST: {
        title: 'തെറാപ്പിസ്റ്റ് പോർട്ടൽ',
        blurb: 'ക്ലയന്റുകളും തെറാപ്പി സെഷനുകളും കൈകാര്യം ചെയ്യുക',
      },
      PARENT: { title: 'പേരന്റ് പോർട്ടൽ', blurb: 'നിങ്ങളുടെ കുട്ടിയുടെ പുരോഗതി ട്രാക്ക് ചെയ്യുക' },
      FINANCE: { title: 'ഫിനാൻസ് പോർട്ടൽ', blurb: 'ബില്ലിംഗ്, ഇൻവോയ്‌സിംഗ്, പേറോൾ' },
    },
    tagline: 'സുരക്ഷിതം • DPDP അനുസരണം • എന്റർപ്രൈസ് ഗ്രേഡ്',
  },
  forgot: {
    title: 'നിങ്ങളുടെ പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യുക',
    subtitle: 'നിങ്ങളുടെ ഇമെയിൽ നൽകുക, ഞങ്ങൾ നിങ്ങൾക്ക് ഒരു റീസെറ്റ് ലിങ്ക് അയയ്ക്കും.',
    submit: 'റീസെറ്റ് ലിങ്ക് അയയ്ക്കുക',
    sentTitle: 'നിങ്ങളുടെ ഇമെയിൽ പരിശോധിക്കുക',
    sentBody:
      'ആ ഇമെയിലിന് ഒരു അക്കൗണ്ട് നിലവിലുണ്ടെങ്കിൽ, നിങ്ങളുടെ പാസ്‌വേഡ് റീസെറ്റ് ചെയ്യാൻ ഞങ്ങൾ ഒരു ലിങ്ക് അയച്ചിട്ടുണ്ട്. ലിങ്ക് 1 മണിക്കൂറിനുള്ളിൽ കാലഹരണപ്പെടും.',
    backToLogin: 'ലോഗിനിലേക്ക് മടങ്ങുക',
  },
  pagination: {
    prev: 'മുമ്പത്തേത്',
    next: 'അടുത്തത്',
    pageOf: 'പേജ് {{page}} / {{total}}',
  },
  account: {
    changePassword: {
      title: 'പാസ്‌വേഡ് മാറ്റുക',
      subtitle: 'നിങ്ങളുടെ അക്കൗണ്ടിന്റെ പാസ്‌വേഡ് അപ്‌ഡേറ്റ് ചെയ്യുക.',
      current: 'നിലവിലെ പാസ്‌വേഡ്',
      new: 'പുതിയ പാസ്‌വേഡ്',
      submit: 'പാസ്‌വേഡ് അപ്‌ഡേറ്റ് ചെയ്യുക',
      success: 'നിങ്ങളുടെ പാസ്‌വേഡ് അപ്‌ഡേറ്റ് ചെയ്തു.',
      error:
        'നിങ്ങളുടെ പാസ്‌വേഡ് മാറ്റാനായില്ല. നിങ്ങളുടെ നിലവിലെ പാസ്‌വേഡ് പരിശോധിച്ച് വീണ്ടും ശ്രമിക്കുക.',
    },
  },
  setPassword: {
    title: 'നിങ്ങളുടെ പാസ്‌വേഡ് സജ്ജമാക്കുക',
    subtitle: 'നിങ്ങളുടെ അക്കൗണ്ട് സജീവമാക്കാൻ ഒരു പാസ്‌വേഡ് തിരഞ്ഞെടുക്കുക.',
    newPassword: 'പുതിയ പാസ്‌വേഡ്',
    confirmPassword: 'പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക',
    submit: 'പാസ്‌വേഡ് സജ്ജമാക്കുക',
    missingToken: 'ഈ ലിങ്ക് അസാധുവാണ് അല്ലെങ്കിൽ അതിന്റെ ടോക്കൺ ഇല്ല.',
    error:
      'ഈ ലിങ്ക് അസാധുവാണ് അല്ലെങ്കിൽ കാലഹരണപ്പെട്ടു. ഇത് വീണ്ടും അയയ്ക്കാൻ നിങ്ങളുടെ ക്ലിനിക്കിനോട് ആവശ്യപ്പെടുക.',
    doneTitle: 'പാസ്‌വേഡ് സജ്ജമാക്കി',
    doneBody: 'നിങ്ങളുടെ അക്കൗണ്ട് സജീവമാണ്. നിങ്ങൾക്ക് ഇപ്പോൾ സൈൻ ഇൻ ചെയ്യാം.',
    goToLogin: 'ലോഗിനിലേക്ക് പോകുക',
  },
  staffLogin: {
    title: 'സ്റ്റാഫ് കൺസോൾ',
    subtitle: 'iTech ആന്തരിക ആക്‌സസ് മാത്രം',
    totp: 'ഓതന്റിക്കേറ്റർ കോഡ്',
    totpPlaceholder: '6-അക്ക കോഡ്',
    signIn: 'സൈൻ ഇൻ',
  },
  nav: {
    dashboard: 'ഡാഷ്‌ബോർഡ്',
    clients: 'ക്ലയന്റുകൾ',
    therapists: 'തെറാപ്പിസ്റ്റുകൾ',
    sessions: SESSIONS,
    reports: REPORTS,
    finance: 'ഫിനാൻസ്',
    analytics: 'അനലിറ്റിക്‌സ്',
    settings: 'ക്രമീകരണങ്ങൾ',
    staffUsers: 'സ്റ്റാഫ് ഉപയോക്താക്കൾ',
    users: 'ഉപയോക്താക്കൾ',
    myClients: 'എന്റെ ക്ലയന്റുകൾ',
    schedule: 'ഷെഡ്യൂൾ',
    availability: 'ലഭ്യത',
    sessionNotes: 'സെഷൻ കുറിപ്പുകൾ',
    therapyPlans: THERAPY_PLANS,
    messages: 'സന്ദേശങ്ങൾ',
    progress: PROGRESS,
    homeTasks: HOME_TASKS,
    billing: 'ബില്ലിംഗ്',
    invoices: 'ഇൻവോയ്‌സുകൾ',
    catalogue: 'പട്ടിക',
    payments: 'പേയ്‌മെന്റുകൾ',
    payroll: 'പേറോൾ',
  },
  finance: {
    dashboard: {
      invoiced: 'ആകെ ഇൻവോയ്‌സ് ചെയ്തത്',
      collected: 'ശേഖരിച്ചത്',
      outstanding: 'കുടിശ്ശിക',
      invoices: 'ഇൻവോയ്‌സുകൾ',
      revenueTrend: 'വരുമാനം',
      revenueTrendSub: 'ശേഖരിച്ചത്, കഴിഞ്ഞ 6 മാസം',
    },
    invoices: {
      title: 'ഇൻവോയ്‌സുകൾ',
      count: '{{count}} ഇൻവോയ്‌സുകൾ',
      add: 'പുതിയ ഇൻവോയ്‌സ്',
      addSubtitle: 'ഒരു ക്ലയന്റിനായി പുതിയ ഇൻവോയ്‌സ് സൃഷ്ടിക്കുക',
      empty: NO_INVOICES,
      searchPlaceholder: 'ഇൻവോയ്‌സ് നമ്പർ അല്ലെങ്കിൽ കുറിപ്പുകൾ അനുസരിച്ച് തിരയുക…',
      statusFilter: FILTER_BY_STATUS,
      allStatus: ALL_STATUS,
      recordPayment: 'പേയ്‌മെന്റ് രേഖപ്പെടുത്തുക',
      recordPaymentSubtitle: 'ഈ ഇൻവോയ്‌സിനെതിരെ ഒരു പേയ്‌മെന്റ് രേഖപ്പെടുത്തുക',
      col: {
        number: 'ഇൻവോയ്‌സ്',
        client: CLIENT,
        amount: 'തുക',
        balance: 'ബാലൻസ്',
        due: 'അവസാന തീയതി',
        status: STATUS,
      },
    },
    reports: {
      title: REPORTS,
      count: REPORTS_COUNT,
    },
    catalogue: {
      title: 'സേവന പട്ടിക',
      count: '{{count}} സേവനങ്ങൾ',
      add: 'സേവനം ചേർക്കുക',
      addTitle: 'സേവനം ചേർക്കുക',
      editTitle: 'സേവനം തിരുത്തുക',
      subtitle: 'സ്ഥിരസ്ഥിതി വിലയുള്ള ഒരു സേവനം; ഇൻവോയ്‌സുകൾ ഇതിൽ നിന്ന് വില എടുക്കുന്നു.',
      name: 'സേവനത്തിന്റെ പേര്',
      price: 'സ്ഥിരസ്ഥിതി വില (₹)',
      priceHint: 'ഉദാ. 2500',
      description: 'വിവരണം (ഓപ്ഷണൽ)',
      save: 'സേവനം സംരക്ഷിക്കുക',
      empty: 'ഇതുവരെ സേവനങ്ങളില്ല — ആദ്യ ഫീസ് ഇനം ചേർക്കുക.',
      edit: 'സേവനം തിരുത്തുക',
      delete: 'സേവനം നീക്കം ചെയ്യുക',
      inactive: 'നിഷ്‌ക്രിയം',
    },
  },
  reports: {
    recent: 'സമീപകാല റിപ്പോർട്ടുകൾ',
    generate: 'റിപ്പോർട്ട് സൃഷ്ടിക്കുക',
    generateError: 'ആ റിപ്പോർട്ട് ആരംഭിക്കാനായില്ല. ദയവായി വീണ്ടും ശ്രമിക്കുക.',
    loading: 'റിപ്പോർട്ടുകൾ ലോഡ് ചെയ്യുന്നു…',
    error: 'റിപ്പോർട്ടുകൾ ലോഡ് ചെയ്യാനായില്ല.',
    empty: 'ഇതുവരെ റിപ്പോർട്ടുകളില്ല — മുകളിൽ ഒന്ന് സൃഷ്ടിക്കുക.',
    download: 'ഡൗൺലോഡ്',
    field: {
      type: 'റിപ്പോർട്ട് തരം',
      client: CLIENT,
      selectClient: SELECT_A_CLIENT,
      from: 'മുതൽ',
      to: 'വരെ',
    },
    type: {
      client_progress: 'ക്ലയന്റ് പുരോഗതി',
      attendance: 'ഹാജർ',
      revenue: 'വരുമാനം',
    },
    status: {
      queued: 'ക്യൂവിൽ',
      running: 'സൃഷ്ടിക്കുന്നു…',
      succeeded: 'തയ്യാർ',
      failed: 'പരാജയപ്പെട്ടു',
    },
    col: {
      report: 'റിപ്പോർട്ട്',
      status: STATUS,
      created: 'സൃഷ്ടിച്ചത്',
      action: '',
    },
  },
  invoiceStatus: {
    draft: DRAFT,
    sent: 'അയച്ചു',
    partial: 'ഭാഗികം',
    paid: PAID,
    overdue: 'കാലാവധി കഴിഞ്ഞു',
    void: 'അസാധു',
  },
  payroll: {
    title: 'പേറോൾ',
    count: '{{count}} റണ്ണുകൾ',
    add: 'പുതിയ പേറോൾ റൺ',
    addSubtitle: 'ഒരു പേ കാലയളവിനായി പേറോൾ റൺ സൃഷ്ടിക്കുക',
    empty: 'ഇതുവരെ പേറോൾ റണ്ണുകളില്ല.',
    colPeriod: 'കാലയളവ്',
    colTotal: 'ആകെ',
    colStatus: STATUS,
    form: {
      period: 'പേ കാലയളവ്',
      periodHint: 'ഉദാ. ജൂൺ 2026',
      start: 'കാലയളവ് ആരംഭം',
      end: 'കാലയളവ് അവസാനം',
      notes: 'കുറിപ്പുകൾ',
      submit: 'റൺ സൃഷ്ടിക്കുക',
      therapist: THERAPIST,
      selectTherapist: 'ഒരു തെറാപ്പിസ്റ്റിനെ തിരഞ്ഞെടുക്കുക',
      gross: 'മൊത്ത ശമ്പളം (₹)',
      sessions: SESSIONS,
      addSubmit: 'പേസ്ലിപ്പ് ചേർക്കുക',
    },
    detail: {
      title: 'പേറോൾ റൺ',
      total: 'ആകെ: {{amount}}',
      addPayslip: 'പേസ്ലിപ്പ് ചേർക്കുക',
      addSubtitle: 'ഈ റണ്ണിലേക്ക് ഒരു തെറാപ്പിസ്റ്റ് പേസ്ലിപ്പ് ചേർക്കുക',
      process: 'പ്രോസസ്സ് ചെയ്യുക',
      empty: 'ഇതുവരെ പേസ്ലിപ്പുകളില്ല.',
      colTherapist: THERAPIST,
      colSessions: SESSIONS,
      colGross: 'മൊത്തം',
    },
  },
  payrollStatus: {
    draft: DRAFT,
    processed: 'പ്രോസസ്സ് ചെയ്തു',
    paid: PAID,
  },
  paymentMethod: {
    cash: 'പണം',
    card: 'കാർഡ്',
    upi: 'UPI',
    bank_transfer: 'ബാങ്ക് ട്രാൻസ്ഫർ',
    razorpay: 'Razorpay',
  },
  home: {
    assign: 'ടാസ്‌ക് നിയോഗിക്കുക',
    assignSubtitle: 'ഈ ക്ലയന്റിനായി ഒരു ഹോം-പ്രോഗ്രാം ടാസ്‌ക് ചേർക്കുക',
  },
  homeCategory: {
    social: 'സാമൂഹികം',
    sensory: 'ഇന്ദ്രിയ',
    cognitive: 'വൈജ്ഞാനികം',
    communication: 'ആശയവിനിമയം',
    motor: 'മോട്ടോർ',
    other: 'മറ്റുള്ളവ',
  },
  analytics: {
    title: 'അനലിറ്റിക്‌സ്',
    subtitle: 'ക്ലിനിക് പ്രകടനം ഒറ്റനോട്ടത്തിൽ',
    financeSubtitle: 'വരുമാനവും ശേഖരണവും ഒറ്റനോട്ടത്തിൽ',
    totalClients: 'ആകെ ക്ലയന്റുകൾ',
    completedSessions: 'പൂർത്തിയായ സെഷനുകൾ',
    sessionsByStatus: 'നില അനുസരിച്ച് സെഷനുകൾ',
    clientsByStatus: 'നില അനുസരിച്ച് ക്ലയന്റുകൾ',
    invoicesByStatus: 'നില അനുസരിച്ച് ഇൻവോയ്‌സുകൾ',
    collections: 'ഇൻവോയ്‌സ് vs ശേഖരണം (₹)',
  },
  settings: {
    title: 'ക്രമീകരണങ്ങൾ',
    subtitle: 'നിങ്ങളുടെ ക്ലിനിക് പ്രൊഫൈൽ കൈകാര്യം ചെയ്യുക',
    name: 'ക്ലിനിക് പേര്',
    legalName: LEGAL_NAME,
    email: CONTACT_EMAIL,
    phone: CONTACT_PHONE,
    timezone: TIMEZONE,
    gstin: 'GSTIN',
    address: 'വിലാസം',
    line1: ADD_LINE_1,
    line2: 'വിലാസ വരി 2',
    city: CITY,
    state: STATE_LABEL,
    postalCode: POSTAL_CODE,
    country: COUNTRY_ISO,
    save: SAVE_CHANGES,
    saved: 'ക്രമീകരണങ്ങൾ സംരക്ഷിച്ചു.',
    tabs: { profile: 'പ്രൊഫൈൽ', notifications: 'അറിയിപ്പുകൾ', security: 'സുരക്ഷ' },
    notifications: {
      sessionReminders: 'സെഷൻ ഓർമ്മപ്പെടുത്തലുകൾ',
      sessionRemindersDesc: 'വരാനിരിക്കുന്ന സെഷനുകൾക്ക് മുമ്പ് ഇമെയിൽ ഓർമ്മപ്പെടുത്തലുകൾ.',
      paymentAlerts: 'പേയ്‌മെന്റ് അലേർട്ടുകൾ',
      paymentAlertsDesc: 'ഇൻവോയ്‌സുകൾ അടച്ചപ്പോഴോ കുടിശ്ശികയായപ്പോഴോ അറിയിക്കുക.',
      progressReports: 'പുരോഗതി റിപ്പോർട്ടുകൾ',
      progressReportsDesc: 'പുരോഗതി റിപ്പോർട്ട് തയ്യാറാകുമ്പോൾ അറിയിക്കുക.',
      systemUpdates: 'സിസ്റ്റം അപ്‌ഡേറ്റുകൾ',
      systemUpdatesDesc: 'പ്ലാറ്റ്‌ഫോം, പരിപാലന അറിയിപ്പുകൾ.',
    },
    security: {
      subtitle: 'നിങ്ങളുടെ അക്കൗണ്ട് പാസ്‌വേഡ് മാറ്റുക. ഈ ഉപകരണത്തിൽ നിങ്ങൾ സൈൻ ഇൻ ആയി തുടരും.',
    },
  },
  messages: {
    title: 'സന്ദേശങ്ങൾ',
    new: 'പുതിയ സന്ദേശം',
    newSubtitle: 'ഒരു കോൺടാക്റ്റുമായി സംഭാഷണം ആരംഭിക്കുക',
    empty: 'ഇതുവരെ സന്ദേശങ്ങളില്ല.',
    conversation: 'സംഭാഷണം',
    composer: 'ഒരു സന്ദേശം ടൈപ്പ് ചെയ്യുക…',
    noContacts: 'സന്ദേശം അയയ്ക്കാൻ കോൺടാക്റ്റുകളില്ല.',
    selectContact: 'ഒരു കോൺടാക്റ്റ് തിരഞ്ഞെടുക്കുക',
    startChat: 'ചാറ്റ് ആരംഭിക്കുക',
    pickConversation: 'ചാറ്റ് ആരംഭിക്കാൻ ഒരു സംഭാഷണം തിരഞ്ഞെടുക്കുക',
  },
  sa: {
    dashboard: {
      title: 'പ്ലാറ്റ്‌ഫോം അവലോകനം',
      subtitle: 'TherapyOS ലെ എല്ലാ ക്ലിനിക്കുകളും ഒറ്റനോട്ടത്തിൽ',
      empty: 'ഇതുവരെ ഡാറ്റയില്ല.',
      totalClinics: 'ആകെ ക്ലിനിക്കുകൾ',
      activeClinics: 'സജീവ ക്ലിനിക്കുകൾ',
      mrr: 'പ്രതിമാസ ആവർത്തന വരുമാനം',
      health: 'ആരോഗ്യം (G / A / R)',
      healthHint: 'പച്ച / ആംബർ / ചുവപ്പ്',
      topBySessions: 'സെഷനുകൾ അനുസരിച്ച് മികച്ച ക്ലിനിക്കുകൾ',
      topByRevenue: 'വരുമാനം അനുസരിച്ച് മികച്ച ക്ലിനിക്കുകൾ (₹)',
    },
    clinics: {
      title: 'ക്ലിനിക്കുകൾ',
      count: '{{count}} ക്ലിനിക്കുകൾ',
      add: 'പുതിയ ക്ലിനിക്',
      empty: 'ഇതുവരെ ക്ലിനിക്കുകളൊന്നും ഓൺബോർഡ് ചെയ്തിട്ടില്ല.',
      searchPlaceholder: 'പേര്, പ്ലാൻ അല്ലെങ്കിൽ നില അനുസരിച്ച് തിരയുക…',
      colName: CLIENT,
      colStatus: STATUS,
      colPlan: PLAN,
      colMrr: MRR,
      colTherapists: THERAPIST,
      colActiveClients: 'സജീവ ക്ലയന്റുകൾ',
    },
    subscriptions: {
      title: 'സബ്‌സ്ക്രിപ്ഷനുകൾ',
      count: '{{count}} ക്ലിനിക്കുകൾ',
      empty: 'ഇതുവരെ സബ്‌സ്ക്രിപ്ഷനുകളില്ല.',
      col: {
        clinic: 'ക്ലിനിക്',
        plan: PLAN,
        status: STATUS,
        mrr: MRR,
        renews: 'പുതുക്കൽ / ട്രയൽ അവസാനം',
        actions: '',
      },
      markPaid: 'പണമടച്ചതായി അടയാളപ്പെടുത്തുക',
      status: {
        active: ACTIVE,
        trialing: TRIAL,
        past_due: 'കുടിശ്ശിക',
        suspended: SUSPENDED,
        cancelled: 'റദ്ദാക്കി',
        none: 'പ്ലാൻ ഇല്ല',
      },
    },
    usage: {
      title: 'ഉപയോഗവും ആരോഗ്യവും',
      healthSummary: '{{green}} പച്ച · {{amber}} ആംബർ · {{red}} ചുവപ്പ്',
      empty: 'ഇതുവരെ ഉപയോഗ ഡാറ്റയില്ല.',
      col: {
        clinic: 'ക്ലിനിക്',
        health: 'ആരോഗ്യം',
        sessions: 'സെഷനുകൾ (30ദി)',
        whatsapp: 'വാട്ട്‌സാപ്പ്',
        sms: 'SMS',
        pdfs: 'PDF-കൾ',
        storage: 'സ്റ്റോറേജ്',
        users: 'സജീവ ഉപയോക്താക്കൾ',
      },
      health: {
        green: 'ആരോഗ്യകരം',
        amber: 'അപകടത്തിൽ',
        red: 'ഗുരുതരം',
        unknown: 'അജ്ഞാതം',
      },
    },
    staff: {
      title: 'സ്റ്റാഫ് ഉപയോക്താക്കൾ',
      count: '{{count}} സ്റ്റാഫ് അക്കൗണ്ടുകൾ',
      add: 'സ്റ്റാഫ് ഉപയോക്താവിനെ ചേർക്കുക',
      empty: 'ഇതുവരെ സ്റ്റാഫ് അക്കൗണ്ടുകളില്ല.',
      active: ACTIVE,
      inactive: 'പ്രവർത്തനരഹിതം',
      enable: 'പ്രവർത്തനക്ഷമമാക്കുക',
      disable: 'പ്രവർത്തനരഹിതമാക്കുക',
      col: {
        member: 'അംഗം',
        role: 'റോൾ',
        status: STATUS,
        lastLogin: 'അവസാന ലോഗിൻ',
        actions: '',
      },
      role: {
        PLATFORM_OWNER: 'പ്ലാറ്റ്‌ഫോം ഉടമ',
        CUSTOMER_SUCCESS: 'കസ്റ്റമർ സക്‌സസ്',
        SUPPORT: 'പിന്തുണ',
        READONLY_AUDITOR: 'വായന-മാത്രം ഓഡിറ്റർ',
      },
      form: {
        fullName: FULL_NAME,
        email: EMAIL,
        role: 'റോൾ',
        submit: 'അക്കൗണ്ട് സൃഷ്ടിക്കുക',
        error: 'അക്കൗണ്ട് സൃഷ്ടിക്കാനായില്ല (ഇമെയിൽ ഉപയോഗത്തിലുണ്ടാകാം).',
      },
      created: {
        title: 'അക്കൗണ്ട് സൃഷ്ടിച്ചു',
        intro: '{{email}} മായി ഈ ക്രെഡൻഷ്യലുകൾ സുരക്ഷിതമായി പങ്കിടുക.',
        copy: 'പകർത്തുക',
        warning: 'ഒരിക്കൽ മാത്രം കാണിക്കും — അംഗം ആദ്യ ലോഗിനിൽ ഈ പാസ്‌വേഡ് മാറ്റണം.',
        done: 'പൂർത്തിയായി',
      },
    },
    clinicStatus: {
      active: ACTIVE,
      trial: TRIAL,
      trialing: TRIAL,
      suspended: SUSPENDED,
      cancelled: CANCELLED,
      past_due: 'കുടിശ്ശിക',
    },
    detail: {
      back: 'ക്ലിനിക്കുകളിലേക്ക് മടങ്ങുക',
      notFound: 'ക്ലിനിക് കണ്ടെത്തിയില്ല.',
      overview: 'അവലോകനം',
      legalName: LEGAL_NAME,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE,
      timezone: TIMEZONE,
      createdAt: 'ഓൺബോർഡ് ചെയ്തു',
      subscription: SUBSCRIPTION,
      noSubscription: 'സജീവ സബ്‌സ്ക്രിപ്ഷൻ ഇല്ല.',
      plan: PLAN,
      subStatus: STATUS,
      mrr: MRR,
      periodEnd: 'പുതുക്കൽ',
      therapists: THERAPIST,
      activeClients: 'സജീവ ക്ലയന്റുകൾ',
      sessions: SESSIONS,
      invoiced: 'ഇൻവോയ്‌സ് ചെയ്തു',
      recentAudit: 'സമീപകാല പ്രവർത്തനം',
      noAudit: 'സമീപകാല പ്രവർത്തനമില്ല.',
    },
    audit: {
      title: 'ഓഡിറ്റ് ലോഗ്',
      subtitle: 'എല്ലാ ക്ലിനിക്കുകളിലുമുള്ള പ്ലാറ്റ്‌ഫോം-വ്യാപക പ്രവർത്തനം',
      empty: 'ഈ ഫിൽട്ടറുകൾക്ക് ഓഡിറ്റ് എൻട്രികളൊന്നും പൊരുത്തപ്പെടുന്നില്ല.',
      allClinics: 'എല്ലാ ക്ലിനിക്കുകളും',
      filterClinic: 'ക്ലിനിക് അനുസരിച്ച് ഫിൽട്ടർ ചെയ്യുക',
      filterAction: 'നടപടി അനുസരിച്ച് ഫിൽട്ടർ ചെയ്യുക…',
      filterFrom: 'തീയതി മുതൽ',
      filterTo: 'തീയതി വരെ',
      colTime: TIME,
      colClinic: 'ക്ലിനിക്',
      colActor: 'നടൻ',
      colAction: ACTION,
      colEntity: 'എന്റിറ്റി',
    },
    settings: {
      title: 'പ്ലാറ്റ്‌ഫോം ക്രമീകരണങ്ങൾ',
      subtitle: 'ഫീച്ചർ ഫ്ലാഗുകളും പ്ലാറ്റ്‌ഫോം കോൺഫിഗറേഷനും',
      flags: 'ഫീച്ചർ ഫ്ലാഗുകൾ',
      empty: 'ഇതുവരെ ഫീച്ചർ ഫ്ലാഗുകളില്ല. താഴെ ഒന്ന് ചേർക്കുക.',
      enabled: 'പ്രവർത്തനക്ഷമം',
      disabled: 'പ്രവർത്തനരഹിതം',
      enable: 'പ്രവർത്തനക്ഷമമാക്കുക',
      disable: 'പ്രവർത്തനരഹിതമാക്കുക',
      addKey: 'ഒരു ഫീച്ചർ ഫ്ലാഗ് ചേർക്കുക',
      addPlaceholder: 'ഉദാ. parent_app_v2',
      add: 'ചേർക്കുക',
      col: {
        key: 'ഫ്ലാഗ്',
        state: 'നില',
        updated: 'അപ്ഡേറ്റ് ചെയ്തു',
      },
    },
    wizard: {
      title: 'ഒരു ക്ലിനിക് ഓൺബോർഡ് ചെയ്യുക',
      subtitle: 'ക്ലിനിക്, അതിന്റെ ആദ്യ അഡ്മിൻ, ഒരു സജീവ സബ്‌സ്ക്രിപ്ഷൻ എന്നിവ സൃഷ്ടിക്കുക',
      stepOf: '{{total}} ൽ ഘട്ടം {{step}}',
      clinicName: 'ക്ലിനിക് പേര്',
      legalName: LEGAL_NAME,
      contactEmail: CONTACT_EMAIL,
      contactPhone: CONTACT_PHONE,
      line1: ADD_LINE_1,
      city: CITY,
      state: STATE_LABEL,
      postalCode: POSTAL_CODE,
      country: 'രാജ്യം (ISO 3166-1 alpha-2)',
      adminName: 'ആദ്യ അഡ്മിൻ പേര്',
      adminEmail: 'ആദ്യ അഡ്മിൻ ഇമെയിൽ',
      planSlug: PLAN,
      trialDays: 'ട്രയൽ ദിവസങ്ങൾ (ഓപ്ഷണൽ)',
      back: 'പിന്നോട്ട്',
      next: 'അടുത്തത്',
      submit: 'ക്ലിനിക് ഓൺബോർഡ് ചെയ്യുക',
    },
  },
  banner: {
    impersonation:
      '⚠ നിങ്ങൾ {{clinic}} നെ {{staff}} ആയി കാണുകയാണ് — എല്ലാ നടപടികളും ഓഡിറ്റ്-ലോഗ് ചെയ്യപ്പെടുന്നു. സെഷൻ {{remaining}} ൽ അവസാനിക്കും.',
    readOnly: 'അക്കൗണ്ട് വായന-മാത്രം മോഡിലാണ് — തുടരാൻ നിങ്ങളുടെ സബ്‌സ്ക്രിപ്ഷൻ പുതുക്കുക.',
  },
} as const;
